module.exports = {
        srcSet: __webpack_public_path__ + "0ed7cc6948d589d9-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "0ed7cc6948d589d9-1000.webp",width: 1000,height: 562}],
        src: __webpack_public_path__ + "0ed7cc6948d589d9-1000.webp",
        toString: function(){return __webpack_public_path__ + "0ed7cc6948d589d9-1000.webp"},
        
        width: 1000,
        height: 562
      }